var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-container" }, [
    _c(
      "div",
      { staticClass: "itens-1" },
      [
        _c(
          "div",
          { staticClass: "select" },
          [
            _c("v-select", {
              staticClass: "input",
              attrs: {
                items: _vm.caregoryList,
                "item-text": "name",
                "item-value": "value",
                "menu-props": { bottom: true, offsetY: true },
                placeholder: "Selecione",
                color: "secondary",
                dense: "",
                required: "",
                outlined: "",
                rounded: ""
              },
              on: {
                change: function($event) {
                  return _vm.onChange($event)
                }
              },
              model: {
                value: _vm.valueToModel,
                callback: function($$v) {
                  _vm.valueToModel = $$v
                },
                expression: "valueToModel"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "btn-rentabilidade", on: { click: _vm.cycle } },
          [_vm._v("Rentabilidade")]
        ),
        _c("DateRange", { on: { "date-range-changed": _vm.changeInterval } })
      ],
      1
    ),
    _vm.switchState
      ? _c("div", { ref: "btnsAtivos", staticClass: "btns-ativos" }, [
          _c(
            "div",
            { staticClass: "btn-cdi" },
            [
              _c("v-switch", {
                attrs: { checked: "", label: "CDI" },
                on: {
                  change: function($event) {
                    return _vm.changeSwitch("CDI")
                  }
                },
                model: {
                  value: _vm.switchStateCDI,
                  callback: function($$v) {
                    _vm.switchStateCDI = $$v
                  },
                  expression: "switchStateCDI"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-ipca" },
            [
              _c("v-switch", {
                attrs: { checked: "", label: "IPCA" },
                on: {
                  change: function($event) {
                    return _vm.changeSwitch("IPCA")
                  }
                },
                model: {
                  value: _vm.switchStateIPCA,
                  callback: function($$v) {
                    _vm.switchStateIPCA = $$v
                  },
                  expression: "switchStateIPCA"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-dolar" },
            [
              _c("v-switch", {
                attrs: { label: "DÓLAR" },
                on: {
                  change: function($event) {
                    return _vm.changeSwitch("DOLAR")
                  }
                },
                model: {
                  value: _vm.switchStateDOLAR,
                  callback: function($$v) {
                    _vm.switchStateDOLAR = $$v
                  },
                  expression: "switchStateDOLAR"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-ibovespa" },
            [
              _c("v-switch", {
                attrs: { label: "IBOVESPA" },
                on: {
                  change: function($event) {
                    return _vm.changeSwitch("IBOVESPA")
                  }
                },
                model: {
                  value: _vm.switchStateIBOVESPA,
                  callback: function($$v) {
                    _vm.switchStateIBOVESPA = $$v
                  },
                  expression: "switchStateIBOVESPA"
                }
              })
            ],
            1
          ),
          _vm._m(0),
          _vm._m(1)
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn-view" }, [
      _c("div", { attrs: { id: "csv-view-link" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn-cart" }, [
      _c("div", { attrs: { id: "csv-cart-link" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }